<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Pagination" });
import { InputRadioList } from "../../selects/index.js";
import { QUERY_STATE } from "../../stores/query.js";
import Button from "../../elements/button/Button.svelte";
import { onMount, getContext } from "svelte";
const SCOPE = getContext("scope");
const LIMITS = [25, 50, 100];
const OPTIONS = LIMITS.map((limit) => ({
    key: limit.toString(),
    label: `${limit} Items`
}));
let currentOffset = 0;
let currentLimit = "25";
export let count;
const setPage = (value) => {
    QUERY_STATE.setParameter("offset", value, SCOPE);
};
const setLimit = (limit) => {
    setPage(0);
    QUERY_STATE.setParameter("limit", Number(limit), SCOPE);
};
const subscribeScope = () => {
    QUERY_STATE.subscribeScope(SCOPE, (data) => {
        if (data === null) {
            return;
        }
        if (data.offset !== currentOffset) {
            return;
        }
        if (data.limit !== Number(currentLimit)) {
            return;
        }
        setPage(0);
    });
};
const subscribePageParameter = () => {
    QUERY_STATE.subscribeParameter("offset", (offset) => {
        if (typeof offset !== "number") {
            return;
        }
        currentOffset = offset;
    }, SCOPE);
};
const subscribeLimitParameter = () => {
    QUERY_STATE.subscribeParameter("limit", (limit) => {
        if (typeof limit !== "number") {
            return;
        }
        currentLimit = limit.toString();
    }, SCOPE);
};
$: setLimit(currentLimit);
onMount(() => {
    subscribeScope();
    subscribePageParameter();
    subscribeLimitParameter();
});
</script>

<div class = 's8-pagination'>

    <Button
        on:click = { setPage.bind(null, currentOffset - Number(currentLimit)) }
        isDisabled = { currentOffset <= 0 }
        icon = 'arrowLeft'
        size = 'xxs'
        color = 'dark'
    />

    <Button
        on:click = { setPage.bind(null, currentOffset + Number(currentLimit)) }
        isDisabled = { $count < Number(currentLimit) }
        icon = 'arrowRight'
        size = 'xxs'
        color = 'dark'
    />

    <span>Page { (currentOffset / Number(currentLimit)) + 1 }</span>

    <InputRadioList
        bind:key = { currentLimit }
        name = 'pagination.limit'
        options = { OPTIONS }
        align = 'horizontal'
    />

</div>

<style>
    div.s8-pagination {
        display: flex;
        align-items: center;
        -moz-column-gap: 10px;
             column-gap: 10px;
        margin-bottom: 10px;
    }

        div.s8-pagination :global(>:last-child) {
            margin-left: auto
        }</style>